<template>
<div>
  <OrganizationsContextCard/>
  <v-container v-if="selectedVehicle != null" class="fleet--overview--context__container pa-0">
    <v-row class="pa-0 fleet--overview--context__layout" no-gutters>
      <v-col cols="12">
        <ContextItemEditableInput
          :eventName="'click'"
          :value="selectedVehicle.name"
          :emptyValue="`${$t('organizations.add')} ${$t('companies.name')}`"
          @save-emitted="handleUpdateName"
          :title="true"
          :savedByEnter="true"
        />
        <!-- <ContextTitle :title__20="true" :title="selectedVehicle.name" :enableInfoIcon="false" /> -->
      </v-col>
      <v-col class="pt-2" cols="12">
        <ContextItemNoEditable
        :iconTooltip="$t('organizations.name')"
        :icon="'fas fa-building'"
        :value="selectedVehicle.organization.name"
        />
        <ContextItemEditableInput
          :iconTooltip="$t('fleet.model')"
          :icon="'fas fa-truck'"
          :eventName="'click'"
          :value="selectedVehicle.model"
          :emptyValue="`${$t('fleet.add_model')}`"
          @save-emitted="handleSetModel"
          :savedByEnter="true"
        />
        <ContextItemAutoComplete
            :eventName="'click'"
            :iconTooltip="$t('fleet.type')"
            :emptyValue="$t('fleet.add_type')"
            :icon="'fas fa-truck-moving'"
            :value="selectedVehicle.type"
            @autocompleteSave="handleUpdateType"
            :list="vehicleTypeList"
            translate="fleet"
          />
         <ContextItemEditableInput
          :iconTooltip="$t('fleet.licence_plate')"
          :icon="'fas fa-bus'"
          :eventName="'click'"
          :value="selectedVehicle.plateNumber"
          :emptyValue="`${$t('fleet.add_licence_plate')}`"
          @save-emitted="handleSetPlateNumber"
          :savedByEnter="true"
        />
        <ContextItemEditableValue
          :iconTooltip="$t('fleet.vehicle_dimensions')"
          :icon="'fas fa-ruler-combined'"
          :attribute="computeVehicleLimitsDimensions.attribute"
          :eventName="'click'"
          :valuesObject="{ translate: 'fleet', length: selectedVehicle.vehicleLimits.length, width: selectedVehicle.vehicleLimits.width, height: selectedVehicle.vehicleLimits.height,  text: computeVehicleLimitsDimensions.value + ' cm', measurement: 'cm', splitter: 'x'}"
          @save-emitted="handleSetVehicleLimitDimensions"
          :savedByEnter="true"
        />
         <ContextItemEditableValue
          :iconTooltip="$t('fleet.vehicle_max_weight')"
          :icon="'fas fa-box-open'"
          :attribute="$t('fleet.vehicle_max_weight')"
          :eventName="'click'"
          :valuesObject="{ translate: 'fleet', maxWeight: computeVehicleLimitsMaxWeight, text: computeVehicleLimitsMaxWeight + ' kg', measurement: 'kg' }"
          :savedByEnter="true"
          @save-emitted="handleSetVehicleLimitMaxWeight"
          :isMaxContentFlex="true"
        />
        <ContextItemLabels
          :isEditable="true"
          :iconTooltip="$t('fleet.labels')"
          :labels="computeVehicleLabels"
          :emptyLabel="`${$t('general.add_labels')}`"
          :eventName="'click'"
          @handleSaveLabels="handleSetVehicleLabels"
          :algoliaSearchLabels="null"
        />
        <ContextItemLabels
          :isEditable="true"
          :icon="'fas fa-tools'"
          :iconTooltip="$t('fleet.equipment')"
          :labels="computedVehicleEquipment"
          :emptyLabel="`${$t('fleet.add_equipment')}`"
          :eventName="'click'"
          @handleSaveLabels="handleSetEquipment"
          :algoliaSearchLabels="null"
          :allowCustomLabels="false"
          :labelsList="fleetAvailableEquipment"
          translate="equipment"
        />
      </v-col>
      <v-col class="pt-3" cols="12">
        <ContextTitle :title="$t('fleet.load_area')" :enableInfoIcon="false"/>
        <ContextItemEditableValue
          :iconTooltip="$t('fleet.load_area_dimensions')"
          :icon="'fas fa-ruler-combined'"
          :attribute="computeLoadAreaDimensions.attribute"
          :eventName="'click'"
          :valuesObject="{ translate: 'fleet', length: selectedVehicle.loadArea.length, width: selectedVehicle.loadArea.width, height: selectedVehicle.loadArea.height,  text: computeLoadAreaDimensions.value + ' cm', measurement: 'cm', splitter: 'x'}"
          @save-emitted="handleSetLoadAreaDimensions"
          :savedByEnter="true"
        />
         <ContextItemEditableValue
          :iconTooltip="$t('fleet.load_area_max_weight')"
          :icon="'fas fa-box-open'"
          :attribute="$t('fleet.load_area_max_weight')"
          :eventName="'click'"
          :valuesObject="{ translate: 'fleet', maxWeight: computeLoadAreaMaxWeight, text: computeLoadAreaMaxWeight + ' kg', measurement: 'kg' }"
          :savedByEnter="true"
          @save-emitted="handleSetLoadAreaMaxWeight"
          :isMaxContentFlex="true"
        />
      </v-col>
      <v-col class="pt-3" cols="12">
        <ContextTitle :title="$t('fleet.trailer')" :enableInfoIcon="false"/>
         <ContextItemEditableValue
          :iconTooltip="$t('fleet.trailer_dimensions')"
          :icon="'fas fa-ruler-combined'"
          :attribute="computeTrailerDimensions.attribute"
          :eventName="'click'"
          :valuesObject="{ length: selectedVehicle.trailer.length, width: selectedVehicle.trailer.width, height: selectedVehicle.trailer.height,  text: computeTrailerDimensions.value + ' cm', measurement: 'cm', splitter: 'x'}"
          @save-emitted="handleSetTrailerDimensions"
          :savedByEnter="true"
        />
         <ContextItemEditableValue
          :iconTooltip="$t('fleet.trailer_max_weight')"
          :icon="'fas fa-box-open'"
          :attribute="$t('fleet.trailer_max_weight')"
          :eventName="'click'"
          :valuesObject="{ translate: 'fleet', maxWeight: computeTrailerMaxWeight, text: computeTrailerMaxWeight + ' kg', measurement: 'kg' }"
          :savedByEnter="true"
          @save-emitted="handleSetTrailerMaxWeight"
          :isMaxContentFlex="true"
        />
      </v-col>
      <v-col class="pt-3" cols="12">
        <VehicleDepot :depot="selectedVehicle.depot" :vehicle="selectedVehicle"/>
      </v-col>
      <v-col class="pt-3" cols="12">
        <ContextTitle :title="$t('fleet.pricing')" :enableInfoIcon="false"/>
        <template
          v-for="priceType in vehiclePriceTypeList"
        >
          <div
          :key="priceType"
          >
            <VehiclePricePerKM
            :key="selectedVehicle.id"
            :pricePerKM="selectedVehicle[`${handleVehiclePriceAttributeBasedOnPriceType(priceType)}`]"
            :priceType="priceType"
            :vehicle="selectedVehicle"
            />
          </div>
        </template>
      </v-col>
      <v-col cols="12" class="pt-3 pb-1">
        <RemoveVehicle :vehicle="selectedVehicle" />
      </v-col>
    </v-row>
  </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { vehicleService } from '@/_services'
import ContextItemNoEditable from '@/components/wrld/generic/ContextItemNoEditable.vue'
import ContextItemEditableValue from '@/components/wrld/generic/ContextItemEditableValue.vue'
import ContextItemEditableInput from '@/components/wrld/generic/ContextItemEditableInput.vue'
import ContextItemLabels from '@/components/wrld/generic/ContextItemLabels.vue'
import ContextItemAutoComplete from '@/components/wrld/generic/ContextItemAutoComplete.vue'
import VehiclePricePerKM from '@/components/organizations/fleet/VehiclePricePerKM.vue'
import VehicleDepot from '@/components/organizations/fleet/VehicleDepot.vue'
import ContextTitle from '@/components/drops/detail/ContextTitle'
import OrganizationsContextCard from '@/components/organizations/OrganizationsContextCard'
import RemoveVehicle from '@/components/organizations/fleet/RemoveVehicle'

export default {
  name: 'FleetOverviewContext',
  components: {
    ContextItemNoEditable,
    ContextItemEditableValue,
    ContextItemEditableInput,
    ContextItemLabels,
    ContextItemAutoComplete,
    VehiclePricePerKM,
    VehicleDepot,
    ContextTitle,
    OrganizationsContextCard,
    RemoveVehicle
  },
  props: {},
  data () {
    return {
      fleetAvailableEquipment: [],
      vehicleTypeList: [],
      vehiclePriceTypeList: [],
    }
  },
  created () {
    vehicleService.getRestrictionsEnum().then((response) => {
      this.fleetAvailableEquipment = response.map(({ name }) => {
        return name
      })
    })
    vehicleService.getVehicleTypeEnum().then((response) => {
      this.vehicleTypeList = response.map(({ name }) => {
        return {
          text: name,
          type: name,
          id: name
        }
      })
    })
    vehicleService.getVehiclePriceTypeEnum().then((response) => {
      this.vehiclePriceTypeList = response.map(({ name }) => {
        return name
      })
    })
  },
  computed: {
    ...mapGetters([
      'getSelectedResourceSecond'
    ]),
    selectedVehicle () {
      return this.getSelectedResourceSecond
    },
    computeVehicleLimitsDimensions () {
      let totalVehicleLimits = null
      if (this.selectedVehicle != null) {
        totalVehicleLimits = this.$options.filters.dimensionValue(this.selectedVehicle.vehicleLimits)
        return { attribute: this.$i18n.t('fleet.vehicle_dimensions') + ' ', value: totalVehicleLimits, isLoading: false }
      }
      return { attribute: null, value: null, isLoading: true }
    },
    computeVehicleLimitsMaxWeight: function () {
      return this.$options.filters.roundValueWeight(this.selectedVehicle.vehicleLimits.maxWeight, 0)
    },
    computeLoadAreaDimensions () {
      let totalVehicleLoadArea = null
      if (this.selectedVehicle != null) {
        totalVehicleLoadArea = this.$options.filters.dimensionValue(this.selectedVehicle.loadArea)
        return { attribute: this.$i18n.t('fleet.load_area_dimensions') + ' ', value: totalVehicleLoadArea, isLoading: false }
      }
      return { attribute: null, value: null, isLoading: true }
    },
    computeLoadAreaMaxWeight: function () {
      return this.$options.filters.roundValueWeight(this.selectedVehicle.loadArea.maxWeight, 0)
    },
    computeTrailerDimensions () {
      let totalTrailerDimensions = null
      if (this.selectedVehicle != null) {
        totalTrailerDimensions = this.$options.filters.dimensionValue(this.selectedVehicle.trailer)
        return { attribute: this.$i18n.t('fleet.trailer_dimensions') + ' ', value: totalTrailerDimensions, isLoading: false }
      }
      return { attribute: null, value: null, isLoading: true }
    },
    computeTrailerMaxWeight () {
      return this.$options.filters.roundValueWeight(this.selectedVehicle.trailer.maxWeight, 0)
    },
    computeVehicleLabels () {
      let vehicleLabels = []
      if (this.selectedVehicle.labels !== null) {
        this.selectedVehicle.labels.forEach((label) => {
          vehicleLabels.push({ name: label, color: '#ef476f', noTranslate: true })
        })
      }
      return vehicleLabels
    },
    computedVehicleEquipment () {
      let vehicleEquipment = []
      if (this.selectedVehicle.equipment != null) {
        this.selectedVehicle.equipment.forEach((label) => {
          vehicleEquipment.push({ name: label, color: '#ef476f', noTranslate: true })
        })
      }
      return vehicleEquipment
    }
  },
  methods: {
    ...mapActions({
      setOrganizationVehicleName: 'setOrganizationVehicleName',
      setOrganizationVehicleModel: 'setOrganizationVehicleModel',
      setOrganizationVehiclePlateNumber: 'setOrganizationVehiclePlateNumber',
      setOrganizationVehicleLimitsDimensions: 'setOrganizationVehicleLimitsDimensions',
      setOrganizationVehicleLimitsMaxWeight: 'setOrganizationVehicleLimitsMaxWeight',
      setOrganizationVehicleLoadAreaDimensions: 'setOrganizationVehicleLoadAreaDimensions',
      setOrganizationVehicleLoadAreaMaxWeight: 'setOrganizationVehicleLoadAreaMaxWeight',
      setOrganizationVehicleTrailerDimensions: 'setOrganizationVehicleTrailerDimensions',
      setOrganizationVehicleTrailerMaxWeight: 'setOrganizationVehicleTrailerMaxWeight',
      setOrganizationVehicleEquipment: 'setOrganizationVehicleEquipment',
      setOrganizationVehicleLabels: 'setOrganizationVehicleLabels',
      setOrganizationVehicleType: 'setOrganizationVehicleType'
    }),
    handleUpdateName (value) {
      this.setOrganizationVehicleName({
        item: { ...this.selectedVehicle, name: value },
        vehicleID: this.selectedVehicle.id,
        name: value
      })
    },
    handleSetModel (value) {
      this.setOrganizationVehicleModel({
        item: { ...this.selectedVehicle, model: value },
        vehicleID: this.selectedVehicle.id,
        model: value
      })
    },
    handleSetPlateNumber (value) {
      this.setOrganizationVehiclePlateNumber({
        item: { ...this.selectedVehicle, plateNumber: value },
        vehicleID: this.selectedVehicle.id,
        plateNumber: value
      })
    },
    handleSetVehicleLimitDimensions (dimensions) {
      let newDimesions = {}
      dimensions.forEach(({ key, value }) => {
        newDimesions[key] = value
      })
      const vehicleLimits = { ...this.selectedVehicle.vehicleLimits, ...newDimesions }
      this.setOrganizationVehicleLimitsDimensions({
        item: { ...this.selectedVehicle, vehicleLimits },
        vehicleID: this.selectedVehicle.id,
        vehicleLimits
      })
    },
    handleSetVehicleLimitMaxWeight (weight) {
      let newMaxWeight = {}
      weight.forEach(({ key, value }) => {
        newMaxWeight[key] = Number(value) * 1000
      })
      const vehicleLimits = { ...this.selectedVehicle.vehicleLimits, ...newMaxWeight }
      this.setOrganizationVehicleLimitsMaxWeight({
        item: { ...this.selectedVehicle, vehicleLimits },
        vehicleID: this.selectedVehicle.id,
        vehicleLimits
      })
    },
    handleSetVehicleLabels (labels) {
      const newLabels = labels.map(({ name }) => name)
      let remove = []
      let add = []
      if (this.selectedVehicle.labels != null) {
        this.selectedVehicle.labels.forEach((label) => {
          if (newLabels.indexOf(label) < 0) {
            remove.push(label)
          }
        })
      }
      newLabels.forEach((label) => {
        if (this.selectedVehicle.labels != null) {
          if (this.selectedVehicle.labels.indexOf(label) < 0) {
            add.push(label)
          }
        } else {
          add.push(label)
        }

      })
      const item = { ...this.selectedVehicle, labels: newLabels}
      this.setOrganizationVehicleLabels({ item, vehicleID: this.selectedVehicle.id, remove, add})
    },
    handleSetLoadAreaDimensions (dimensions) {
      let newDimesions = {}
      dimensions.forEach(({ key, value }) => {
        newDimesions[key] = value
      })
      const loadArea = { ...this.selectedVehicle.loadArea, ...newDimesions }
      this.setOrganizationVehicleLoadAreaDimensions({
        item: { ...this.selectedVehicle, loadArea },
        vehicleID: this.selectedVehicle.id,
        loadArea
      })
    },
    handleSetLoadAreaMaxWeight (weight) {
      let newMaxWeight = {}
      weight.forEach(({ key, value }) => {
        newMaxWeight[key] = Number(value) * 1000
      })
      const loadArea = { ...this.selectedVehicle.loadArea, ...newMaxWeight }
      this.setOrganizationVehicleLoadAreaMaxWeight({
        item: { ...this.selectedVehicle, loadArea },
        vehicleID: this.selectedVehicle.id,
        loadArea
      })
    },
    handleSetTrailerDimensions (dimensions) {
      let newDimesions = {}
      dimensions.forEach(({ key, value }) => {
        newDimesions[key] = value
      })
      const trailer = { ...this.selectedVehicle.trailer, ...newDimesions }
      this.setOrganizationVehicleTrailerDimensions({
        item: { ...this.selectedVehicle, trailer },
        vehicleID: this.selectedVehicle.id,
        trailer
      })
    },
    handleSetTrailerMaxWeight (weight) {
     let newMaxWeight = {}
      weight.forEach(({ key, value }) => {
        newMaxWeight[key] = Number(value) * 1000
      })
      const trailer = { ...this.selectedVehicle.trailer, ...newMaxWeight }
      this.setOrganizationVehicleTrailerMaxWeight({
        item: { ...this.selectedVehicle, trailer },
        vehicleID: this.selectedVehicle.id,
        trailer
      })
    },
    handleSetEquipment (equipment) {
      const newEquipment = equipment.map(({ name }) => name)
      let remove = []
      let add = []
      if (this.selectedVehicle.equipment != null) {
        this.selectedVehicle.equipment.forEach((label) => {
          if (newEquipment.indexOf(label) < 0) {
            remove.push(label)
          }
        })
      }
      newEquipment.forEach((label) => {
        if (this.selectedVehicle.equipment != null) {
          if (this.selectedVehicle.equipment.indexOf(label) < 0) {
            add.push(label)
          }
        } else {
          add.push(label)
        }
      })
      this.setOrganizationVehicleEquipment({
        item: { ...this.selectedVehicle, equipment: newEquipment },
        vehicleID: this.selectedVehicle.id,
        add,
        remove
      })
    },
    handleUpdateType(value) {
      this.setOrganizationVehicleType({
        vehicle: { ...this.selectedVehicle, type: value.type },
        vehicleType: value.type
      })
    },
    handleVehiclePriceAttributeBasedOnPriceType(priceType) {
      switch (priceType) {
        case 'PerEmptyKM':
          return 'pricePerEmptyKM'
        case 'PerFullKM':
          return 'pricePerFullKM'
        case 'Minimal':
          return 'minimalPrice'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
